'use strict'

import BusinessPlanApi from './../api/businessPlan.js'

const state = {
  data: null,
  loading: false,
  error: null
}

const getters = {
  isAlreadySubmitted (state, getters) {
    return Boolean(state.data && state.data.video_link && state.data.file)
  }
}

const mutations = {
  request (state) {
    state.error = null
    state.data = null
    state.loading = true
  },

  requestFailure (state, error) {
    state.error = error
    state.loading = false
  },

  fetchRequestSuccess (state, data) {
    state.data = data
    state.loading = false
  },

  uploadRequestSuccess (state, data) {
    state.data = data
    state.loading = false
  }
}

const actions = {
  fetch ({commit}, token) {
    commit('request')

    BusinessPlanApi.fetch(token)
      .then(response => {
        const data = Array.isArray(response.data)
          ? response.data.pop()
          : response.data
        commit('fetchRequestSuccess', data)
      })
      .catch(error => commit('requestFailure', error))
  },

  upload ({commit}, {token, video_link, file}) {
    commit('request')
    BusinessPlanApi.upload(token, {video_link, file})
      .then(response => {
        const data = Array.isArray(response.data)
          ? response.data.pop()
          : response.data
        commit('uploadRequestSuccess', data)
      })
      .catch(error => commit('requestFailure', error))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
